import type { IconProps } from "./icon-types";

/**
 * GPU 카드(그래픽 카드). GPU/가속기/하드웨어 리소스 진입점에서 사용.
 *
 * `react-icons/bs`의 `BsGpuCard`보다 자세한 GPU 일러스트를 c6 톤에 맞춰 커스텀 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 핀 달린 칩 + 스월(소용돌이) 팬 + 하단 PCIe 커넥터 핀으로 GPU를 또렷하게.
 * 요소가 많아 24 그리드 / stroke 기반에 얇은 선폭(1.5)으로 디테일이 뭉치지 않게 한다.
 */
export const GpuCardIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {/* 카드 보드 */}
    <rect x="2.5" y="3.5" width="19" height="14" rx="3" />
    {/* 칩(다이) + 핀 */}
    <rect x="5.5" y="7.8" width="5" height="5" rx="1.2" />
    <path d="M5.5 8.8H4.5M5.5 10.3H4.5M5.5 11.8H4.5" />
    <path d="M6.7 7.8V6.9M8 7.8V6.9M9.3 7.8V6.9" />
    <path d="M6.7 12.8V13.7M8 12.8V13.7M9.3 12.8V13.7" />
    {/* 팬(스월 블레이드) + 허브 */}
    <circle cx="15.8" cy="10.5" r="4.4" />
    <circle cx="15.8" cy="10.5" r="0.8" />
    <path d="M17.25 10.5Q18.4 12 17.92 13.89" />
    <path d="M16.53 11.76Q15.8 13.5 13.92 14.03" />
    <path d="M15.08 11.76Q13.2 12 11.8 10.64" />
    <path d="M14.35 10.5Q13.2 9 13.68 7.11" />
    <path d="M15.08 9.24Q15.8 7.5 17.68 6.97" />
    <path d="M16.53 9.24Q18.4 9 19.8 10.36" />
    {/* 하단 PCIe 커넥터 핀 */}
    <path d="M6 17.5V19M8 17.5V19M10 17.5V19M12 17.5V19M14 17.5V19M16 17.5V19M18 17.5V19" />
  </svg>
);
